
import React from 'react';

export function EmptyCategoriesList() {
  return (
    <div className="text-center p-8 border border-dashed rounded-lg">
      <p className="text-muted-foreground">No categories yet. Add your first category to get started.</p>
    </div>
  );
}
